jQuery(document).ready(function () {
    jQuery(window).scroll(function () {
        let content = '.content',
            bottom = jQuery(content).offset().top,
            topBar = '#top-bar-menu';
            offCanvas = '.off-canvas';

        if (jQuery(this).scrollTop() > bottom) {
            jQuery(topBar).addClass('pinned');
        } else {
            jQuery(topBar).removeClass('pinned');
        }
    });
});